import { isMobile } from "../../../../helpers";

const fonts = {
  font: { name: 'HEYCAZpersonal', path: 'frame/frameModuleResources/main/fonts/HEYCAZpersonal.otf' },
  font1: { name: 'poppinsMedium', path: 'frame/frameModuleResources/main/fonts/poppinsMedium.ttf' },
  font2: { name: 'rockwell', path: 'frame/frameModuleResources/main/fonts/rockwell.ttf' },
};

const bitmapFonts = {
  winPopupNumbers: { name: 'winPopupNumbers', path: 'frame/frameModuleResources/main/bitmapFonts/winPopupNumbers.xml' },
};

const webSceneSpineResources = {
  jackpotCongratsPopup: {
    name: "jackpotCongratsPopup",
    path: 'frame/jackpotModuleResources/jackpotAssets/web/jackpotCongratsPopup/InGame_PopUp.json',
    config: {
      metadata: {
        spineAtlasFile: 'frame/jackpotModuleResources/jackpotAssets/web/jackpotCongratsPopup/InGame_PopUp.atlas',
      },
    },
  },
  jackpotGameSceneBoard: {
    name: "jackpotGameSceneBoard",
    path: 'frame/jackpotModuleResources/jackpotAssets/web/jackpotBgScene/background_web.json',
    config: {
      metadata: {
        spineAtlasFile: 'frame/jackpotModuleResources/jackpotAssets/web/jackpotBgScene/background_web.atlas',
      },
    },
  },
  jackPotItem: {
    name: "jackPotItem",
    path: 'frame/jackpotModuleResources/jackpotAssets/web/jackpotSymbolContainer/container.json',
    config: {
      metadata: {
        spineAtlasFile: 'frame/jackpotModuleResources/jackpotAssets/web/jackpotSymbolContainer/container.atlas',
      },
    },
  },
  jackpotAmountBoard: {
    name: "jackpotAmountBoard",
    path: 'frame/jackpotModuleResources/jackpotAssets/web/jackpotAmountBoard/Amount_containers.json',
    config: {
      metadata: {
        spineAtlasFile: 'frame/jackpotModuleResources/jackpotAssets/web/jackpotAmountBoard/Amount_containers.atlas',
      },
    },
  },
  jackPotSymbol: {
    name: "jackPotSymbol",
    path: 'frame/jackpotModuleResources/jackpotAssets/web/jackpotIcons/jackpotSymbols.json',
    config: {
      metadata: {
        spineAtlasFile: 'frame/jackpotModuleResources/jackpotAssets/web/jackpotIcons/jackpotSymbols.atlas',
      },
    },
  },
  jackpotWinPopup: {
    name: "jackpotWinPopup",
    path: 'frame/jackpotModuleResources/jackpotAssets/web/jackpotWinPopupAnimation/win.json',
    config: {
      metadata: {
        spineAtlasFile: 'frame/jackpotModuleResources/jackpotAssets/web/jackpotWinPopupAnimation/win.atlas',
      },
    },
  },
}

const mobileSceneSpineResources = {
  jackpotCongratsPopup: {
    name: "jackpotCongratsPopup",
    path: 'frame/jackpotModuleResources/jackpotAssets/mobile/jackpotCongratsPopup/InGame_PopUp.json',
    config: {
      metadata: {
        spineAtlasFile: 'frame/jackpotModuleResources/jackpotAssets/mobile/jackpotCongratsPopup/InGame_PopUp.atlas',
      },
    },
  },
  jackpotGameSceneBoard: {
    name: "jackpotGameSceneBoard",
    path: 'frame/jackpotModuleResources/jackpotAssets/mobile/jackpotBgScene/background_web.json',
    config: {
      metadata: {
        spineAtlasFile: 'frame/jackpotModuleResources/jackpotAssets/mobile/jackpotBgScene/background_web.atlas',
      },
    },
  },
  jackPotItem: {
    name: "jackPotItem",
    path: 'frame/jackpotModuleResources/jackpotAssets/mobile/jackpotSymbolContainer/container.json',
    config: {
      metadata: {
        spineAtlasFile: 'frame/jackpotModuleResources/jackpotAssets/mobile/jackpotSymbolContainer/container.atlas',
      },
    },
  },
  jackpotAmountBoard: {
    name: "jackpotAmountBoard",
    path: 'frame/jackpotModuleResources/jackpotAssets/mobile/jackpotAmountBoard/Amount_containers.json',
    config: {
      metadata: {
        spineAtlasFile: 'frame/jackpotModuleResources/jackpotAssets/mobile/jackpotAmountBoard/Amount_containers.atlas',
      },
    },
  },
  jackPotSymbol: {
    name: "jackPotSymbol",
    path: 'frame/jackpotModuleResources/jackpotAssets/mobile/jackpotIcons/jackpotSymbols.json',
    config: {
      metadata: {
        spineAtlasFile: 'frame/jackpotModuleResources/jackpotAssets/mobile/jackpotIcons/jackpotSymbols.atlas',
      },
    },
  },
  jackpotWinPopup: {
    name: "jackpotWinPopup",
    path: 'frame/jackpotModuleResources/jackpotAssets/mobile/jackpotWinPopupAnimation/win.json',
    config: {
      metadata: {
        spineAtlasFile: 'frame/jackpotModuleResources/jackpotAssets/mobile/jackpotWinPopupAnimation/win.atlas',
      },
    },
  },
  jackpotBackGroundLights: {
    name: "jackpotBackGroundLights",
    path: 'frame/jackpotModuleResources/jackpotAssets/mobile/jackpotBackGround/bg_lights.json',
    config: {
      metadata: {
        spineAtlasFile: 'frame/jackpotModuleResources/jackpotAssets/mobile/jackpotBackGround/bg_lights.atlas',
      },
    },
  },
  jackpotBackGroundLogo: {
    name: "jackpotBackGroundLogo",
    path: 'frame/jackpotModuleResources/jackpotAssets/mobile/jackpotBackGround/bg_logo.json',
    config: {
      metadata: {
        spineAtlasFile: 'frame/jackpotModuleResources/jackpotAssets/mobile/jackpotBackGround/bg_logo.atlas',
      },
    },
  },
  jackpotBackGroundProjector: {
    name: "jackpotBackGroundProjector",
    path: 'frame/jackpotModuleResources/jackpotAssets/mobile/jackpotBackGround/bg_projector.json',
    config: {
      metadata: {
        spineAtlasFile: 'frame/jackpotModuleResources/jackpotAssets/mobile/jackpotBackGround/bg_projector.atlas',
      },
    },
  },
  jackpotBackGroundStage: {
    name: "jackpotBackGroundStage",
    path: 'frame/jackpotModuleResources/jackpotAssets/mobile/jackpotBackGround/bg_stage.json',
    config: {
      metadata: {
        spineAtlasFile: 'frame/jackpotModuleResources/jackpotAssets/mobile/jackpotBackGround/bg_stage.atlas',
      },
    },
  },
  jackpotBackGroundStars: {
    name: "jackpotBackGroundStars",
    path: 'frame/jackpotModuleResources/jackpotAssets/mobile/jackpotBackGround/bg_stars.json',
    config: {
      metadata: {
        spineAtlasFile: 'frame/jackpotModuleResources/jackpotAssets/mobile/jackpotBackGround/bg_stars.atlas',
      },
    },
  },
}

const webAtlases = {
  jackpot: {
    name: 'jackpot',
    path: 'frame/jackpotModuleResources/images/web/jackpotModuleImages.json',
  }
};

const mobileAtlases = {
  jackpot: {
    name: 'jackpot',
    path: 'frame/jackpotModuleResources/images/mobile/jackpotModuleImages.json',
  }
};

export const jackpotResources = [
  ...Object.values(fonts),
  ...Object.values(bitmapFonts),
  ...Object.values(isMobile() ? mobileSceneSpineResources : webSceneSpineResources),
  ...Object.values(isMobile() ? mobileAtlases : webAtlases),

];
